import { render, staticRenderFns } from "./CompareMarketSection.vue?vue&type=template&id=1d7577c3&scoped=true"
import script from "./CompareMarketSection.vue?vue&type=script&lang=js"
export * from "./CompareMarketSection.vue?vue&type=script&lang=js"
import style0 from "./CompareMarketSection.vue?vue&type=style&index=0&id=1d7577c3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d7577c3",
  null
  
)

export default component.exports